import { Modal } from 'almanac-ui/Modal'
import { ReactComponent as HtmlIcon } from './icons/Html.svg'
import { ReactComponent as MarkdownIcon } from './icons/Markdown.svg'
import { ReactComponent as PdfIcon } from './icons/Pdf.svg'
import cx from 'classnames'
import RadioButtonStyle from 'components/RadioButton/RadioButton.module.scss'
import { RadioButtons } from 'components/RadioButton/RadioButtons'
import { capitalize } from 'lodash'
import Styles from './Export.module.scss'
import { ExportFormatEnum, ExportViewState, PdfPaperSize } from './Types'

const SelectedIndicator = () => {
  return (
    <div className={Styles.indicatorBorder}>
      <div className={Styles.indicatorCenter}></div>
    </div>
  )
}

interface ExportOptionProp {
  logo: React.ReactNode
  title: string
  subTitle: string
  selected: boolean
  onSelect: () => void
  children?: React.ReactNode
}

export const ExportOption = ({ logo, title, subTitle, selected, onSelect, children }: ExportOptionProp) => {
  return (
    <div className={cx(Styles.optionContainer, { [Styles.selectedOptionContainer]: selected })} onClick={onSelect}>
      {logo}
      <div className={Styles.optionContentContainer}>
        <div className={Styles.optionTitle}>{title}</div>
        <div className={Styles.optionSubTitle}>{subTitle}</div>
        {children && <div className={Styles.optionChildren}>{children}</div>}
      </div>
      {selected && <SelectedIndicator />}
    </div>
  )
}

export const Export = ({
  close,
  onExport,
  exportViewState,
  setExportViewState,
}: {
  close: () => void
  onExport: () => void
  exportViewState: ExportViewState
  setExportViewState: (params: ExportViewState) => void
}) => {
  return (
    <>
      <Modal.Content>
        <div className={Styles.contentWrapper}>
          <div className={Styles.innerContentWrapper}>
            <ExportOption
              logo={<HtmlIcon />}
              title="HTML"
              subTitle="Good for importing into other tools. Retains layout & styles for text and tables."
              selected={exportViewState.format === ExportFormatEnum.Html}
              onSelect={() => setExportViewState({ ...exportViewState, format: ExportFormatEnum.Html })}
            />
            <ExportOption
              logo={<MarkdownIcon />}
              title="Markdown"
              subTitle="Next best after HTML to import into other tools. Retains hierarchy for text and table structure, but not styling."
              selected={exportViewState.format === ExportFormatEnum.Markdown}
              onSelect={() => setExportViewState({ ...exportViewState, format: ExportFormatEnum.Markdown })}
            />
          </div>
          <div className={Styles.secondInnerContentWrapper}>
            <ExportOption
              logo={<PdfIcon />}
              title="PDF"
              subTitle={'Good for preserving style and printing. Select the PDF paper size.'}
              selected={exportViewState.format === ExportFormatEnum.Pdf}
              onSelect={() => setExportViewState({ ...exportViewState, format: ExportFormatEnum.Pdf })}
            >
              <div className={Styles.pdfPaperSizeButtons}>
                <RadioButtons
                  selectedKey={exportViewState.pdfPaperSize}
                  options={Object.values(PdfPaperSize).map((size) => ({
                    key: size,
                    title: capitalize(size),
                    isDisabled: exportViewState.format !== ExportFormatEnum.Pdf,
                  }))}
                  onSelectionChange={(key) =>
                    setExportViewState({ ...exportViewState, pdfPaperSize: key as PdfPaperSize })
                  }
                  classOverrides={{
                    button: cx(Styles.radioButton, RadioButtonStyle.root),
                    title: cx(Styles.radioTitle, RadioButtonStyle.title),
                  }}
                />
              </div>
            </ExportOption>
          </div>
        </div>
      </Modal.Content>
    </>
  )
}
